module.exports = __webpack_public_path__ + "media/application/images/svgs/share-2-82dd589e67bb47c88c394f1c9b2c3ebc.svg";